export const testimonials = [
  {
    name: '小满',
    role: '老瓜民 · 关注 2 年',
    avatar: 'https://readdy.ai/api/search-image?query=Warm%20friendly%20portrait%20of%20a%20young%20asian%20woman%20smiling%20gently%2C%20soft%20cream%20background%2C%20coral%20toned%20natural%20lighting%2C%20simple%20editorial%20headshot&width=200&height=200&seq=txava-01&orientation=squarish',
    text: '睡不着的时候就来这里翻两条，全是软软的小事，看完真的会忍不住笑出来。',
  },
  {
    name: '阿堇',
    role: '甜瓜投稿人',
    avatar: 'https://readdy.ai/api/search-image?query=Warm%20friendly%20portrait%20of%20a%20young%20asian%20man%20with%20a%20soft%20grin%2C%20plain%20warm%20beige%20background%2C%20gentle%20natural%20light%2C%20clean%20editorial%20headshot&width=200&height=200&seq=txava-02&orientation=squarish',
    text: '把我和她的小事投出去之后被认真编辑了，标题取特别好，读起来像一段预告片。',
  },
  {
    name: 'Lulu',
    role: '每日订阅用户',
    avatar: 'https://readdy.ai/api/search-image?query=Soft%20portrait%20of%20a%20cheerful%20asian%20woman%20with%20short%20hair%2C%20cream%20and%20peach%20background%2C%20warm%20daylight%2C%20minimal%20editorial%20headshot&width=200&height=200&seq=txava-03&orientation=squarish',
    text: '定了甜瓜日报之后，通勤路上终于不是刷焦虑了，三条瓜刚好够看完一站地铁。',
  },
];

export const stats = [
  { label: '已整理甜味瓜', value: '1,240+', icon: 'ri-heart-2-line' },
  { label: '每日精选推送', value: '3 条', icon: 'ri-mail-send-line' },
  { label: '甜度好评率', value: '98.6%', icon: 'ri-emotion-happy-line' },
  { label: '投稿收录故事', value: '360 篇', icon: 'ri-quill-pen-line' },
];

export default testimonials;